import {WuTooltip} from '@/components/tooltip'
import {cn} from '@/lib/utils'
import {useEffect, useRef, useState} from 'react'

// TruncatedLabel Component
export const WuTruncatedLabel: React.FC<{
  label: string
  className?: string
}> = ({label, className}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  useEffect(() => {
    const container = containerRef.current
    if (container) {
      const containerWidth = container.clientWidth
      const scrollWidth = container.scrollWidth
      const averageCharWidth = scrollWidth / label.length
      const estimatedWidth = label.length * averageCharWidth
      setIsTruncated(
        estimatedWidth > containerWidth || scrollWidth > containerWidth,
      )
    }
  }, [label])

  return (
    <p ref={containerRef} className={cn('w-full truncate', className)}>
      {isTruncated ? (
        <WuTooltip content={label} positionOffset={8}>
          {label}
        </WuTooltip>
      ) : (
        label
      )}
    </p>
  )
}
